export default "__VITE_ASSET__CqRd0rTi__"